import messages from './shell.json' with { type: 'json' };

export const shellEn: Readonly<typeof messages> = messages;
